import React, { useEffect, useState } from 'react'
import prod from "../assets/prod.jpg"
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { SlArrowUp } from "react-icons/sl";
import { SlArrowDown } from "react-icons/sl";
import { GrDocumentPdf } from "react-icons/gr";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import oth1 from "../assets/oth1.jpg"
import oth2 from "../assets/oth2.jpg"
import oth3 from "../assets/oth3.jpg"
import oth4 from "../assets/oth4.jpg"
import oth5 from "../assets/oth5.jpg"
import oth6 from "../assets/oth6.jpg"
import oth7 from "../assets/oth7.jpg"
import oth8 from "../assets/oth8.jpg"
import oth9 from "../assets/oth9.jpg"
// import oth10 from "../assets/oth10.jpg"
import oth11 from "../assets/oth11.jpg"
import oth12 from "../assets/oth12.jpg"
import oth13 from "../assets/oth13.jpg"
import oth14 from "../assets/oth14.jpg"
import oth15 from "../assets/oth15.jpg"
import oth16 from "../assets/oth16.jpg"
import oth17 from "../assets/oth17.jpg"
import oth18 from "../assets/oth18.jpg"
import oth19 from "../assets/oth19.jpg"
import oth20 from "../assets/oth20.jpg"
import oth21 from "../assets/oth21.jpg"
import oth22 from "../assets/oth22.jpg"
import oth23 from "../assets/oth23.jpg"
import oth24 from "../assets/oth24.jpg"
// import oth25 from "../assets/oth25.jpg"
// import oth26 from "../assets/oth26.jpg"
// import oth27 from "../assets/oth27.jpg"
// import oth28 from "../assets/oth28.jpg"
import pd1 from "../pdfs/pca-n3060-scu_en.pdf"
import pd2 from "../pdfs/pca-2706xa-niu_en.pdf"
import pd3 from "../pdfs/pca-2707xa-fim_en.pdf"
import pd4 from "../pdfs/pca-n3060-fim2_en.pdf"
import pd5 from "../pdfs/firu009-r-lcd_en.pdf"
import pd6 from "../pdfs/firu009-r-led_en.pdf"
import pd7 from "../pdfs/pca-n3060-ldm_en.pdf"
import pd8 from "../pdfs/cni016n_en.pdf"
import pd9 from "../pdfs/csc004_en.pdf"
import pd10 from "../pdfs/fdku033_d_d_x_en.pdf"
import pd11 from "../pdfs/fdlu019_d_x_en.pdf"
import pd12 from "../pdfs/fdhu003_d_x_en.pdf"
import pd13 from "../pdfs/detector_base_fzbu_series_en-compressed.pdf"
import pd14 from "../pdfs/frru004-cizm4_en.pdf"
import pd15 from "../pdfs/frru004-mcm_en.pdf"
import pd16 from "../pdfs/frru004-scm4_en.pdf"
import pd17 from "../pdfs/frru004-dcm4_en.pdf"
import pd18 from "../pdfs/frru004-trm4_en.pdf"
import pd19 from "../pdfs/frru004-mom4_en.pdf"
import pd20 from "../pdfs/frru004_aim_en.pdf"
import pd21 from "../pdfs/fqiu004_sci_en.pdf"
import pd22 from "../pdfs/frru004-gscu_en.pdf"
import Footer from './Footer';
import { Link, useLocation } from 'react-router-dom';
import Navigation from './Navigation';

const OtherDevices = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    const [isOpen, setIsOpen] = useState(false);
    const [isAddressableOpen, setIsAddressableOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        if (["/address", "/n3060", "/n765", "/smoke", "/other", "/flame"].includes(currentPath)) {
            setIsOpen(true);
        }

        if (["/address", "/n3060", "/n765"].includes(currentPath)) {
            setIsAddressableOpen(true);
        }

        if (["/nn100"].includes(currentPath)) {
            setIsOpen1(true);
        }

        if (["/foam", "/foamm"].includes(currentPath)) {
            setIsOpen2(true);
        }
    }, [currentPath]);


    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>
            <div className="relative overflow-hidden">
                <img src={prod} alt="Product" className={`w-full h-auto object-cover transition-transform duration-1000 ${isVisible ? 'scale-100' : 'scale-110'}`} />

                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Products
                    </h1>
                </div>
            </div>

            <div className="w-full px-4 xl:px-20 py-3 xl:py-5 overflow-hidden">
                <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <Link to="/" className="uppercase text-green-700 hover:underline transition-colors duration-300">
                        Home
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <Link to="/products" className="uppercase text-md md:text-lg text-green-700 hover:underline">
                        Products
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <Link to="/address" className="text-md md:text-lg text-green-700 hover:underline">
                        Addressable Systems
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <p className="text-md md:text-lg text-gray-800">
                        Common Devices
                    </p>
                </div>
            </div>

            <div className="px-2 xl:px-20 py-4 xl:py-6">
                <div className="flex flex-col-reverse lg:flex-row gap-8 items-start justify-start">

                    <div className="w-full lg:w-auto">
                        <div className="py-2">
                            <Link to="/products">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className="text-xl text-gray-900 uppercase group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Products
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Fire Alarm Systems
                                    </h1>
                                    {isOpen ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen && (
                                    <div className="mt-4 bg-white px-4 py-3">
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center py-1 border-b border-gray-300 cursor-pointer" onClick={() => setIsAddressableOpen(!isAddressableOpen)}>
                                                <h1 className="text-lg font-semibold text-gray-800 mb-2 mt-1">
                                                    Addressable Systems
                                                </h1>
                                                {isAddressableOpen ? (
                                                    <SlArrowUp className="text-gray-500 w-4 h-4" />
                                                ) : (
                                                    <SlArrowDown className="text-gray-500 w-4 h-4" />
                                                )}
                                            </div>
                                            {isAddressableOpen && (
                                                <div>
                                                    <Link to="/address">
                                                        <h2 className={`text-md mt-4 mb-3 pl-3 ${currentPath === "/address" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>
                                                            Addressable Systems TOP
                                                        </h2>
                                                    </Link>

                                                    <Link to="/n3060">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n3060" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N3060
                                                        </h2>
                                                    </Link>
                                                    <Link to="/n765">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n765" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N765
                                                        </h2>
                                                    </Link>
                                                    <div className="border-b border-gray-300"></div>
                                                </div>
                                            )}

                                            <Link to="/smoke">
                                                <div className="py-1 border-b border-gray-300">
                                                    <h1 className={`text-lg font-semibold mt-1 mb-2 ${currentPath === "/smoke" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Aspirating Smoke Detector (Protecview)
                                                    </h1>
                                                </div>
                                            </Link>
                                            <Link to="/other">
                                                <div className="py-1">
                                                    <h1 className={`text-lg font-semibold mt-1 ${currentPath === "/other" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Common Devices
                                                    </h1>
                                                </div>
                                            </Link>
                                            <Link to="/flame">
                                                <div className="py-1"><h1 className={`text-lg font-semibold mt-1 ${currentPath === "/flame" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                    IR3 Flame Detectors
                                                </h1>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen1(!isOpen1)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Nitrogen Gas Fire Suppression Systems
                                    </h1>
                                    {isOpen1 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen1 && (
                                    <div className="mt-4 bg-white px-4 py-4">
                                        <div className="space-y-2">
                                            <Link to="/nn100">
                                                <div className="border-b border-gray-300 pb-3">
                                                    <h2 className={`text-lg font-semibold ${currentPath === "/nn100" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Engineered Type (NN100)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/nn100">
                                                <div className="pb-1 mt-1">
                                                    <h2 className="text-lg font-semibold text-gray-800 hover:text-green-600 mt-2">Package Type</h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen2(!isOpen2)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Foam Extinguishing Systems
                                    </h1>
                                    {isOpen2 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen2 && (
                                    <div className="mt-4 bg-white px-2 xl:px-4 py-2 xl:py-4">
                                        <div className="space-y-2">
                                            <Link to="/foam">
                                                <div className="border-b border-gray-300 pb-2">
                                                    <h2 className={`text-lg font-semibold mb-1 ${currentPath === "/foam" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        High Expansion Foam (Perf-EX)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/foamm">
                                                <div className="pb-1 mt-2">
                                                    <h2 className={`text-lg font-semibold  mt-2 ${currentPath === "/foamm" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Package Type (MIDEX III)
                                                    </h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <Link to="/video">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className={`text-xl flex-1 pr-3 transition-colors duration-300 ${currentPath === "/video" ? "text-green-600" : "text-gray-800 group-hover:text-green-600"}`}>
                                        Product Videos
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {/* Other Devices */}
                    <div className="px-2 xl:px-4">
                        <div className="block md:hidden w-fit mb-6">
                            <div className="flex items-center gap-3 bg-gray-200 text-gray-700 text-sm font-medium px-6 py-2 shadow-sm">
                                <FaArrowLeftLong className="w-3 h-3" />
                                <Link to="/address" className="hover:underline">
                                    Back to Addressable Systems
                                </Link>
                            </div>
                        </div>

                        <div className="flex flex-col items-start w-full">
                            <h1 className="text-2xl xl:text-4xl font-semibold">Common Devices</h1>
                            <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />
                        </div>

                        <div className="mt-10">
                            <h1 className="text-2xl xl:text-4xl font-semibold text-gray-800">
                                Product Data Sheets
                            </h1>
                            <div className="flex w-20 h-1 mt-4">
                                <div className="w-1/2 bg-green-700" />
                                <div className="w-1/2 bg-gray-400" />
                            </div>

                            {/* box 1 */}
                            <div className="flex flex-col items-start w-full mt-8">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">
                                    Fire Alarm Control Panel
                                </h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full max-w-6xl" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 mb-6 w-full">
                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth1} alt="Alarm" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Sub Control Unit</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd1} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        PCA-N3060-SCU
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth2} alt="Alarm" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Network Interface Unit</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd2} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150 whitespace-nowrap">
                                                        PCA-2706XA-NIU
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth3} alt="Alarm" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">
                                                Fiber-optic Interface Module
                                            </h1>
                                            <div className="flex flex-wrap items-center">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd3} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150 whitespace-nowrap">
                                                        PCA-2707XA-FIM
                                                    </h2>
                                                    <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>

                                            <div className="flex flex-wrap items-center mt-2">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd4} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150 whitespace-nowrap">
                                                        PCA-N3060-FIM2
                                                    </h2>
                                                    <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* box 2 */}
                            <div className="flex flex-col items-start w-full mt-8">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">
                                    Remote Annunciator / LED Driver
                                </h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full max-w-6xl" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 mb-6 w-full">
                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth4} alt="LCD" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-3 px-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                LCD Type Remote Annunciator
                                            </h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd5} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 hover:border-b hover:border-green-700 transition-all duration-150 whitespace-nowrap">
                                                        FIRU009-R-LCD
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth5} alt="LED" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-3 px-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">LED Type Remote Annunciator</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd6} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 hover:border-b hover:border-green-700 transition-all duration-150 whitespace-nowrap">
                                                        FIRU009-R-LED
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth6} alt="LED Driver" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-3 px-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">LED Driver Module</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd7} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150 whitespace-nowrap">
                                                        PCA-N3060-LDM
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* box 3 */}
                            <div className="flex flex-col items-start w-full mt-8">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">System Monitor</h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full max-w-6xl" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 mb-4 w-full">
                                    <div className="flex flex-col items-start w-full gap-3">
                                        <div className="w-full flex justify-center">
                                            <img src={oth7} alt="System" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">System Monitoring Program</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd8} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        CNI016N
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-3">
                                        <div className="w-full flex justify-center">
                                            <img src={oth8} alt="System" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">System Interface Unit</h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd9} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        CSC004
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* box 4 */}
                            <div className="flex flex-col items-start w-full mt-8">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">
                                    Addressable Detectors and Bases
                                </h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4 mb-6 w-full">
                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth9} alt="Photoelectric" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Photoelectric Smoke Detector
                                            </h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                    FDKU026-D-X
                                                </h2>
                                                <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-2" />
                                            </div>

                                            <div className="flex items-center flex-wrap mt-2">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd10} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FDKU033-D/D-X
                                                    </h2>
                                                    <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-2" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth10} alt="Combination Detector" className="w-full h-auto object-cover" />
                                        </div>

                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Combination Smoke / Heat Detector
                                            </h1>

                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                    FDKLU026-D-X
                                                </h2>
                                                <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-2" />
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth11} alt="Heat Detector" className="w-full h-auto object-cover" />
                                        </div>

                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Fixed Temperature Heat Detector
                                            </h1>

                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd11} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FDLU019-D-X
                                                    </h2>
                                                    <GrDocumentPdf className="w-6 h-6 text-red-600 cursor-pointer ml-2" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth12} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Rate-of-Rise / Fixed Temperature Heat Detector
                                            </h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd12} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FDHU003-D-X
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth13} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                4-inch Base
                                            </h1>
                                            <div className="flex flex-col group">
                                                <div className="flex items-center gap-1">
                                                    <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                    <a href={pd13} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                        <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                            FZBU004-AB4
                                                        </h2>
                                                    </a>
                                                </div>
                                                <div className="flex items-center gap-2 mt-1 pl-6">
                                                    <a href={pd13} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                        <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6 whitespace-nowrap">
                                                            FZBU013-2Z / FZBU013-4Z
                                                        </h2>
                                                        <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer flex-shrink-0" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth15} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Isolator Base
                                            </h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd13} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FZBU005-AIB
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth14} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col">
                                            <h1 className="text-lg font-bold text-gray-900 mb-2">
                                                Sounder Base
                                            </h1>
                                            <div className="flex items-center flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd13} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FZBU005-ASB
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* box 5 */}
                            <div className="flex flex-col items-start w-full mt-6 mb-8">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">Addressable Modules</h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 mb-4">
                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth16} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">
                                                Conventional Initiating Zone Module
                                            </h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd14} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-CIZM4
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth17} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Miniature Contact Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd15} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-MCM
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth18} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Single Contact Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd16} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-SCM4
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth19} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Dual Contact Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd17} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-DCM4
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth20} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Twin Relay Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd18} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-TRM4
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth21} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Monitored Output Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd19} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-MOM4
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth22} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">Analog Input Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd20} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-AIM
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth23} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">
                                                Short Circuit Isolator
                                            </h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd21} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FQIU004-SCI
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth24} alt="Addressable" className="w-auto h-full object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-lg font-bold text-gray-900 mb-3">
                                                Gus Suppression Control Unit
                                            </h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pd22} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FRRU004-GSCU
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* box 6 */}
                            {/* <div className="flex flex-col items-start w-full mt-8">
                                <h1 className="text-2xl xl:text-3xl text-green-600">Addressable Modules</h1>
                                <div className="border-t-2 border-gray-400 mt-3 w-full " />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 mb-10 w-full">
                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth25} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-xl font-bold text-gray-900 mb-3">Wet Output Type</h1>

                                            <div className="flex flex-col gap-1 group">
                                                <div className="flex items-start gap-1">
                                                    <MdKeyboardArrowRight className="w-5 h-5 text-green-700 mt-1" />
                                                    <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                        FRRJ001A-Y-S
                                                    </h2>
                                                </div>
                                                <div className="flex items-center gap-1 pl-6">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                        FRRJ001-Y-4S
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-2" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth26} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-xl font-bold text-gray-900 mb-3">Dry Contact Type</h1>
                                            <div className="flex flex-col gap-1 group">
                                                <div className="flex items-start gap-1">
                                                    <MdKeyboardArrowRight className="w-5 h-5 text-green-700 mt-1" />
                                                    <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                        FRRJ001A-Y-SS
                                                    </h2>
                                                </div>
                                                <div className="flex items-center gap-1 pl-6">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                        FRRJ001-Y-2SS
                                                    </h2>
                                                </div>
                                                <div className="flex items-center gap-1 pl-6">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent group-hover:border-green-700 pb-[2px] transition-all duration-150 leading-6">
                                                        FRRJ001-Y-4SD
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-2" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth27} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-xl font-bold text-gray-900 mb-3">Gas Detector Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                    FRRJ001A-Y-G
                                                </h2>
                                                <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col items-start w-full gap-4">
                                        <div className="w-full">
                                            <img src={oth28} alt="Addressable" className="w-full h-auto object-cover" />
                                        </div>
                                        <div className="w-full flex flex-col mt-2">
                                            <h1 className="text-xl font-bold text-gray-900 mb-3">Initiating Device Module</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                    FRRJ001-Y-4F/16F
                                                </h2>
                                                <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
            </div >

            <div><Footer /></div>
        </>
    )
}

export default OtherDevices
